<!--
출고 >  오프로드 해지 컴포넌트
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical">

            <div class="uk-modal-header">
                <h4>오프로드 해지</h4>
            </div>

            <div class="uk-modal-body uk-padding-small">

                <app-column
                    class="uk-margin-small-bottom"
                    header="출고번호"
                    header-size="medium"
                    body-size="medium"
                    header-align="left"
                    body-align="left"
                    horizontal
                    header-width="120px"
                >
                    {{ shipout.id }}
                </app-column>

                <app-column
                    class="uk-margin-small-bottom"
                    header="출고일(LOCAL)"
                    header-size="medium"
                    body-size="medium"
                    header-align="left"
                    body-align="left"
                    horizontal
                    header-width="120px"
                >
                    {{ shipout.local_shipout_at_date }}
                </app-column>

                <app-column
                    class="uk-margin-small-bottom"
                    header="출고일(KR)"
                    header-size="medium"
                    body-size="medium"
                    header-align="left"
                    body-align="left"
                    horizontal
                    header-width="120px"
                >
                    {{ shipout.shipout_at_date }}
                </app-column>



                <app-column
                    class="uk-margin-small-bottom"
                    header="MAWB"
                    header-size="medium"
                    body-size="medium"
                    header-align="left"
                    body-align="left"
                    horizontal
                    header-width="120px"
                >
                    {{ shipout.mawb }}
                </app-column>

                <app-column
                    class="uk-margin-small-bottom"
                    header="FLT"
                    header-size="medium"
                    body-size="medium"
                    header-align="left"
                    body-align="left"
                    horizontal
                    header-width="120px"
                >
                    {{ shipout.flt }}
                </app-column>

                <app-column
                    class="uk-margin-small-bottom"
                    header="HAWB-QTY"
                    header-size="medium"
                    body-size="medium"
                    header-align="left"
                    body-align="left"
                    horizontal
                    header-width="120px"
                >
                    {{ shipout.house_count }}
                </app-column>


            </div>


            <div class="uk-modal-footer uk-text-right">

                <div class="uk-margin-bottom uk-text-center">
                    오프로드 설정이 해지됩니다.<br />
                    모든 배송의 배송단계가 <b>항공운송중</b> 단계로 변경됩니다.
                </div>


                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>

                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: check"></span>
                    오프로드 해지
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            /**
             * csrf token
             */
            csrfToken: {
                type: String,
                required: true,
            },


        },
        data: function () {
            return {
                /**
                 * (object) 출고 오브젝트
                 **/
                shipout: {},
            };
        },
        computed: {

        },
        methods: {
            /**
             * 입력폼 display
             */
            show() {
                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             * @param shipout_id 출고ID
             */
            form(shipout_id) {

                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/region-shipouts/' + shipout_id,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.shipout = response.shipout;

                    // 폼띄우기
                    this.show();
                });
            },

            /**
             * submit
             */
            submit() {

                // ajax 옵션
                let opts = {
                    type: 'patch',
                    url: '/region-shipouts/' + this.shipout.id + '/offload',
                    data: {
                        '_token': this.csrfToken,
                        'type': 'unset',
                    },
                    success: (response, textStatus, jqXHR) => {
                        UIkit.modal.alert(response.msg).then(function () {
                            $.app.refresh();
                        });
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>